import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useHistory, Link } from 'react-router-dom';
// eslint-disable-next-line object-curly-newline
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  Paper,
  Card,
  TextField,
  InputAdornment,
  IconButton,
  Grid,
  Menu,
  MenuItem,
} from '@mui/material';

import AddBoxIcon from '@mui/icons-material/AddBox';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import HistoryIcon from '@mui/icons-material/History';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import dayjs from 'dayjs';
import _ from 'lodash';
import 'dayjs/locale/th';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import PropTypes from 'prop-types';
import * as actions from '../../redux/actions';
import Loading from '../../components/Loading';
import { Error, NotAuthorized } from '../../components/Error';
import accessSubModule from '../../utils/functions/accessSubModule';
import { ViewTitle } from '../../components/ViewTitle';
import ExelExport from '../../components/ExcelDownload/ExcelExport';

dayjs.locale('th');
dayjs.extend(buddhistEra);

const OrdersManagement = ({ title, subtitle }) => {
  const module = 'SPM';
  const subModule = 'IMPORT';
  const dispatch = useDispatch();
  const productTransaction = useSelector((state) => state.productTransaction);
  // const productType = useSelector((state) => state.productType);
  const brand = useSelector((state) => state.brand);
  const me = useSelector((state) => state.me);

  const history = useHistory();
  // const product = useSelector((state) => state.product);
  const location = useLocation();
  // Setting React hook form
  const [searchTerm, setSearchTerm] = useState('');
  const [name, setName] = useState('');
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(5);
  const [total, setTotal] = useState(undefined);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectDate, setSelectDate] = useState('');
  const [anchorElAdd, setAnchorElAdd] = useState(null);
  const [anchorElImport, setAnchorElImport] = useState(null);

  const transactionType = 'IMPORT';

  useEffect(() => {
    dispatch(actions.meGet());

    const fetchProductTransaction = async () => {
      try {
        // await dispatch(actions.productTransactionReset());
        await dispatch(
          actions.productTransactionAll({
            name,
            page,
            size,
            transactionType,
            startDate,
            endDate,
            selectDate,
          }),
        );
      } catch (error) {
        console.error(error);
      }
    };
    fetchProductTransaction();
    // dispatch(actions.productTypeAll(''));
    dispatch(actions.brandAll(''));
    return () => { };
  }, [name, page, size, startDate, endDate, selectDate]);

  useEffect(() => {
    setTotal(productTransaction?.total);
    return () => { };
  }, [productTransaction]);
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageFromQuery = parseInt(params.get('page'), 10);
    const sizeFromQuery = parseInt(params.get('size'), 10);
    if (pageFromQuery && pageFromQuery !== page) setPage(pageFromQuery);
    if (sizeFromQuery && sizeFromQuery !== size) setSize(sizeFromQuery);
  }, [location.search]);

  // OrdersManagement.js

  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      setName(searchTerm);
      if (page !== 1) {
        setPage(1);
        // สร้าง params จาก URL ปัจจุบัน
        const params = new URLSearchParams(location.search);
        // ตั้งค่า page เป็น 1 (ค่า size เดิมจะยังคงอยู่)
        params.set('page', '1');
        // อัปเดต URL
        history.replace({ search: params.toString() });
      }
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchTerm]);
  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
    // สร้าง params จาก URL ปัจจุบัน
    const params = new URLSearchParams(location.search);
    // ตั้งค่า page ใหม่ (ค่า size เดิมจะยังคงอยู่)
    params.set('page', newPage + 1);
    // อัปเดต URL
    history.replace({ search: params.toString() });
  };
  const renderTitle = () => <ViewTitle title={title} subtitle={subtitle} />;
  const handleDropdownClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleDropdownClose = () => {
    setAnchorEl(null);
  };
  const handleDelete = async (id) => {
    const confirm = window.confirm('ยืนยันการลบข้อมูล');
    if (confirm) {
      try {
        await dispatch(actions.productTransactionDelete(id));
        await dispatch(
          actions.productTransactionAll({
            name,
            page,
            size,
            transactionType,
            startDate,
            endDate,
            selectDate,
          }),
        );
      } catch (error) {
        console.error(error);
      }
    }
  };

  const handleChangeRowsPerPage = (event) => {
    const newSize = parseInt(event.target.value, 10);
    setSize(newSize);
    setPage(1);
    history.replace({ search: `?page=1` });
  };
  const handleToInfoPage = async (id) => {
    history.push(`/spm/orders/${id}?page=${page}&size=${size}`);
  };
  console.log('size', size);
  // OrdersManagement.js

  const handleToEditPage = async (id) => {
    // นำค่า page และ size จาก state ปัจจุบันมาต่อท้าย URL
    history.push(`/spm/order/edit/${id}?page=${page}&size=${size}`);
  };

  const handleClearDateFilters = () => {
    setStartDate('');
    setEndDate('');
    setSelectDate('');
    setPage(1);
  };

  // ฟังก์ชันสำหรับ Add
  const handleDropdownClickAdd = (event) => setAnchorElAdd(event.currentTarget);
  const handleDropdownCloseAdd = () => setAnchorElAdd(null);

  // ฟังก์ชันสำหรับ Import
  const handleDropdownClickImport = (event) =>
    setAnchorElImport(event.currentTarget);
  const handleDropdownCloseImport = () => setAnchorElImport(null);

  const renderAddButton = () => (
    <div>
      <Button
        startIcon={<AddBoxIcon />}
        variant="contained"
        onClick={handleDropdownClickAdd}
      >
        สร้างใบนำเข้า
      </Button>
      <Menu
        anchorEl={anchorElAdd}
        open={Boolean(anchorElAdd)}
        onClose={handleDropdownCloseAdd}
      >
        <MenuItem
          onClick={() => {
            handleDropdownCloseAdd();
            history.push('/spm/orders/create');
          }}
        >
          สร้างใบนำเข้า
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleDropdownCloseAdd();
            history.push('/spm/orders/create_many');
          }}
        >
          สร้างใบนำเข้าหลายสินค้า
        </MenuItem>
      </Menu>
    </div>
  );

  const renderImportButton = () => (
    <div>
      <Button
        startIcon={<AddBoxIcon />}
        variant="contained"
        onClick={handleDropdownClickImport}
      >
        นำสินค้าเข้าคลัง
      </Button>
      <Menu
        anchorEl={anchorElImport}
        open={Boolean(anchorElImport)}
        onClose={handleDropdownCloseImport}
      >
        <MenuItem
          onClick={() => {
            handleDropdownCloseImport();
            history.push('/spm/orders/create_stock');
          }}
        >
          นำเข้าสินค้า
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleDropdownCloseImport();
            history.push('/spm/orders/create_stockmany');
          }}
        >
          นำเข้าสินค้าหลายรายการ
        </MenuItem>
      </Menu>
    </div>
  );

  const renderSearch = () => (
    <Card>
      <div className="p-4">
        <Grid container spacing={2} alignItems="center">
          {/* Search Field */}
          <Grid item xs={12} md={3}>
            <TextField
              label="ค้นหา"
              fullWidth
              size="small"
              value={searchTerm}
              onChange={(e) => {
                setSearchTerm(e.target.value);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          {/* Select Date */}
          <Grid item xs={12} md={2.5}>
            <TextField
              label="เลือกวันที่"
              type="date"
              fullWidth
              size="small"
              value={selectDate}
              onChange={(e) => {
                setSelectDate(e.target.value);
                setPage(1);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          {/* Start Date */}
          <Grid item xs={12} md={2.5}>
            <TextField
              label="วันที่เริ่มต้นของสัปดาห์"
              type="date"
              fullWidth
              size="small"
              value={startDate}
              onChange={(e) => {
                setStartDate(e.target.value);
                setPage(1);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          {/* End Date */}
          <Grid item xs={12} md={2.5}>
            <TextField
              label="วันที่สิ้นสุดของสัปดาห์"
              type="date"
              fullWidth
              size="small"
              value={endDate}
              onChange={(e) => {
                setEndDate(e.target.value);
                setPage(1);
              }}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>

          {/* Clear Button */}
          <Grid item xs={12} md={1.5}>
            <Button
              fullWidth
              variant="outlined"
              color="secondary"
              startIcon={<ClearIcon />}
              onClick={handleClearDateFilters}
              disabled={!startDate && !endDate && !selectDate}
            >
              ล้าง
            </Button>
          </Grid>
        </Grid>
      </div>
      {/* <div className="p-4 flex flex-col md:flex-row justify-between items-center gap-4">
        <div className="w-full md:w-1/2">
          <TextField
            label="ค้นหา"
            fullWidth
            size="small"
            id="outlined-start-adornment"
            onChange={(e) => {
              setSearchTerm(e.target.value);
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <i className="fas fa-search"></i>
                </InputAdornment>
              ),
            }}
          />
        </div>

      </div> */}
    </Card>
  );

  const renderTable = () => (
    <div className="my-2">
      <Paper>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }}>
            <TableHead>
              <TableRow>
                <TableCell>
                  <div className="font-bold">ลำดับที่</div>
                </TableCell>
                {/* <TableCell>
                  <div className="font-bold">หมายเลขเอกสาร</div>
                </TableCell> */}
                <TableCell>
                  <div className="font-bold">บิล</div>
                </TableCell>
                <TableCell>
                  <div className="font-bold">คู่ค้า</div>
                </TableCell>
                {/* <TableCell>
                  <div className="font-bold">ชื่อสินค้า</div>
                </TableCell> */}
                <TableCell>
                  <div className="font-bold">รุ่นสินค้า</div>
                </TableCell>
                <TableCell>
                  <div className="font-bold">จำนวนสินค้า</div>
                </TableCell>
                <TableCell>
                  <div className="font-bold">คลัง/หมายเลขโครงการ</div>
                </TableCell>
                <TableCell>
                  <div className="font-bold">วันที่นำเข้า</div>
                </TableCell>
                <TableCell>
                  <div className="font-bold">ผู้นำเข้า/รับจริง</div>
                </TableCell>
                {/* <TableCell>
                  <div className="font-bold">ประวัติแก้ไข</div>
                </TableCell> */}
              </TableRow>
            </TableHead>
            <TableBody>
              {!_.isEmpty(productTransaction.rows) ? (
                productTransaction.rows.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    className={index % 2 === 0 ? 'bg-gray-100' : ''}
                  >
                    <TableCell component="th" scope="row">
                      <IconButton color="primary">
                        <EditOutlinedIcon
                          onClick={() => handleToEditPage(row?.id)}
                        />
                      </IconButton>
                      {(page - 1) * size + index + 1}
                    </TableCell>
                    {/* <TableCell component="th" scope="row">
                      <a
                        className="hover:underline cursor-pointer"
                        onClick={() => handleToInfoPage(row?.id)}
                      >
                        {row?.running_number || '-'}
                      </a>
                    </TableCell> */}
                    <TableCell component="th" scope="row">
                      <div>{row?.bill_number || '-'}</div>
                    </TableCell>
                    <TableCell onClick={() => handleToInfoPage(row?.id)}>
                      <a className="hover:underline cursor-pointer">
                        {row?.customer?.name || '-'}
                      </a>
                    </TableCell>
                    {/* <TableCell>
                      {row?.orders?.map((eachOrder, _index) => (
                        <div key={_index} className="w-full py-1">
                          <div className="flex">
                            <p className="">
                              {_index + 1} : {eachOrder?.product?.name}
                            </p>
                          </div>
                        </div>
                      ))}
                    </TableCell> */}
                    <TableCell>
                      {row?.orders?.map((eachOrder, _index) => (
                        <div key={_index} className="w-full py-1">
                          <div className="flex">
                            <p className="">
                              {_index + 1} : {eachOrder?.product?.model_name}
                            </p>
                          </div>
                        </div>
                      ))}
                    </TableCell>
                    <TableCell>
                      {row?.orders?.map((eachOrder, _index) => (
                        <div key={_index} className="w-full py-1">
                          <div className="flex gap-1">
                            <p className="">{eachOrder?.amount}</p>
                            <p className=" ">{eachOrder?.product?.unit}</p>
                          </div>
                        </div>
                      ))}
                    </TableCell>
                    <TableCell>
                      {row?.warehouse
                        ? row?.warehouse?.name
                        : row?.orders?.map((eachOrder, _index) => (
                          <div key={_index} className="w-full py-1">
                            <div className="flex gap-1">
                              <p className="">
                                {eachOrder?.warehouse?.name}/
                                {eachOrder?.project_number || '-'}
                              </p>
                            </div>
                          </div>
                        ))}
                    </TableCell>
                    <TableCell>
                      {`${dayjs(row?.import_date).format('D MMM BBBB ')}`}
                    </TableCell>
                    <TableCell>
                      <div>{row?.import_employee || '-'}</div>
                      <div>{row?.real_import_employee?.firstname || '-'}</div>
                    </TableCell>
                    {/* <TableCell>
                      <IconButton color="primary">
                        <HistoryIcon />
                      </IconButton>
                    </TableCell> */}
                  </TableRow>
                ))
              ) : (
                <TableRow>
                  <TableCell colSpan={6}>
                    <div className="text-center">ไม่มีข้อมูล</div>
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination
          component="div"
          rowsPerPageOptions={[5, 10, 25, 100]}
          onRowsPerPageChange={handleChangeRowsPerPage}
          page={page - 1}
          count={total || 1}
          rowsPerPage={size}
          onPageChange={handleChangePage}
        />
      </Paper>
    </div>
  );

  if (productTransaction.isLoading || !productTransaction.rows) {
    return <Loading />;
  }
  if (!productTransaction.isLoading && productTransaction.isCompleted) {
    if (accessSubModule(me?.userData?.access, module, subModule)) {
      return (
        <div className="">
          <div className="flex justify-between">
            <div>{renderTitle()}</div>
            <div className="mt-6 flex gap-2">
              <div className="flex flex-row justify-end items-center gap-2">
                <div className="w-full md:w-auto pr-2 text-right">
                  <ExelExport
                    productTransactions={productTransaction?.rows}
                    imports={true}
                    dataAPIEndPoint="product-transaction"
                    startDate={startDate}
                    name={name}
                    endDate={endDate}
                    selectDate={selectDate}
                    transactionType={transactionType}
                    // productTypes={productType?.rows}
                    brands={brand?.rows}
                  />
                </div>
                {me?.userData?.access_button?.import && (
                  <>
                    <div>{renderImportButton()}</div>
                  </>
                )}
                {me?.userData?.access_button?.import && (
                  <>
                    <div>{renderAddButton()}</div>
                  </>
                )}
              </div>
            </div>
          </div>
          {renderSearch()}
          {renderTable()}
        </div>
      );
    }
    return <NotAuthorized />;
  }
  return <Error message={productTransaction?.message} />;
};

OrdersManagement.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

OrdersManagement.defaultProps = {
  title: '',
  subtitle: '',
};

export default OrdersManagement;
